import { Fragment, ReactNode, useMemo } from 'react';
import { BrandMark } from '@components/BrandMark';

interface BrandTextProps {
  text?: string | null;
  animated?: boolean;
  className?: string;
}

function buildFragments(text: string, animated: boolean): ReactNode[] {
  const fragments: ReactNode[] = [];
  const pattern = /SendAllFiles(\.[A-Za-z0-9]+)?/g;
  let lastIndex = 0;
  let match: RegExpExecArray | null;

  while ((match = pattern.exec(text)) !== null) {
    if (match.index > lastIndex) {
      fragments.push(text.slice(lastIndex, match.index));
    }

    fragments.push(<BrandMark key={`brand-${match.index}`} animated={animated} />);

    if (match[1]) {
      fragments.push(match[1]);
    }

    lastIndex = pattern.lastIndex;
  }

  if (lastIndex < text.length) {
    fragments.push(text.slice(lastIndex));
  }

  return fragments.length > 0 ? fragments : [text];
}

export function BrandText({ text, animated = false, className }: BrandTextProps) {
  const safeText = text ?? '';
  const fragments = useMemo(() => buildFragments(safeText, animated), [safeText, animated]);

  if (className) {
    return (
      <span className={className}>
        {fragments.map((fragment, index) => (
          <Fragment key={index}>{fragment}</Fragment>
        ))}
      </span>
    );
  }

  return (
    <>
      {fragments.map((fragment, index) => (
        <Fragment key={index}>{fragment}</Fragment>
      ))}
    </>
  );
}
